export enum pageTypes {
  HOME = 'home',
  PROPERTIES_LISTING = 'properties_listing',
  PDP = 'pdp',
  CHECKOUT = 'checkout',
  CHECKOUT_B = 'checkout_b',
  OUR_LOCATIONS = 'our_locations',
  GUEST_HUB = 'guest_hub',
  MAIN_FOOTER = 'main_footer',
  ACCOUNT_BOOKINGS = 'account_bookings',
  HEADER = 'header',
  BOOKING_WIDGET = 'booking_widget',
  HELP_AND_FAQS = 'help_and_faqs'
}
